import { Link } from 'react-router-dom';

const cards = [
  {
    title: 'Тренинг для руководителей',
    desc: 'Практическая программа развития управленческих компетенций: делегирование, контроль, обратная связь, мотивация.',
    href: '/enciklopediya-korporativnogo-obucheniya/trening-dlya-rukovoditeley',
  },
  {
    title: 'Менеджмент и лидерство',
    desc: 'Все направления развития управленческих компетенций для руководителей разных уровней.',
    href: '/menedzhment-i-liderstvo',
  },
  {
    title: 'Обратная связь и сложные разговоры',
    desc: 'Как руководителю обсуждать ошибки, результаты и сложные ситуации с сотрудниками.',
    href: '/menedzhment-i-liderstvo/obratnaya-svyaz-i-slozhnye-razgovory',
  },
  {
    title: 'Управленческие переговоры',
    desc: 'Переговоры руководителя с сотрудниками, коллегами и руководством.',
    href: '/menedzhment-i-liderstvo/upravlencheskie-peregovory',
  },
  {
    title: 'Развитие Soft Skills',
    desc: 'Коммуникация, эмоциональный интеллект и другие гибкие навыки для руководителей и сотрудников.',
    href: '/enciklopediya-korporativnogo-obucheniya/razvitie-soft-skills',
  },
];

export default function ReadNextSection() {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-3">
          Что изучить дальше
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto leading-relaxed">
          Смежные направления обучения для руководителей и компаний
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 max-w-5xl mx-auto">
          {cards.map((card) => (
            <Link
              key={card.href + card.title}
              to={card.href}
              className="bg-gray-50 rounded-xl border border-gray-200 p-5 md:p-6 hover:border-teal-300 transition-colors group cursor-pointer"
            >
              <h3 className="font-bold text-gray-900 text-sm mb-2 group-hover:text-teal-600 transition-colors">{card.title}</h3>
              <p className="text-gray-600 text-xs leading-relaxed mb-3">{card.desc}</p>
              <span className="inline-flex items-center gap-1 text-xs font-semibold text-teal-600">
                Подробнее
                <i className="ri-arrow-right-line"></i>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}